import { atom } from 'jotai';

/**
 * Open state for the globally mounted {@link TrialUpgradeRequestCallbackModal}.
 * Callers should use {@link openTrialUpgradeRequestCallbackModalAtom} /
 * {@link closeTrialUpgradeRequestCallbackModalAtom} rather than writing here
 * directly so the open/close API stays consistent across consumers.
 */
export const trialUpgradeRequestCallbackModalOpenAtom = atom<boolean>(false);

/** Set by callers to open the globally mounted {@link TrialUpgradeRequestCallbackModal}. */
export const openTrialUpgradeRequestCallbackModalAtom = atom(null, (_get, set) => {
  set(trialUpgradeRequestCallbackModalOpenAtom, true);
});

/** Set by callers to close the globally mounted {@link TrialUpgradeRequestCallbackModal}. */
export const closeTrialUpgradeRequestCallbackModalAtom = atom(null, (_get, set) => {
  set(trialUpgradeRequestCallbackModalOpenAtom, false);
});
